/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useState, useRef, useEffect } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './SDEditorStyles.css'; // Your custom styles

function SDEditor({ value, onChange, onSave, fancy = false, disabled = false }) {
    const quillRef = useRef(null);
    const [isFocused, setIsFocused] = useState(false);
    const [editorReady, setEditorReady] = useState(false);
    const [isDirty, setIsDirty] = useState(false);

    const handleFocus = () => setIsFocused(true);

    const handleBlur = () => {
        setIsFocused(false);
    }

    useEffect(() => {
        setIsDirty(false);
        const editor = quillRef.current?.getEditor();
        // editor?.blur(); // This removes focus on load
        const editorElement = editor?.root;

        // Prevent user from leaving the page if they have unsaved changes

        const handleBeforeUnload = (e) => {
            if (isDirty) {
                alert("You have unsaved changes!");
                e.preventDefault();
                e.returnValue = ''; // Required for Chrome
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        if (fancy) {
            if (editorElement) {
                editorElement.tabIndex = -1; // Prevents tab-based focus
                editorElement.addEventListener('focus', handleFocus);
                editorElement.addEventListener('blur', handleBlur);

            }

            // const timer = setTimeout(() => {
            //     const editor = quillRef.current?.getEditor();
            //     editor?.root?.blur(); // This targets the actual editable DOM node
            // }, 100); // Delay to let Quill finish initializing

            // return () => clearTimeout(timer);
        }

        return () => {
            if (editorElement) {
                editorElement.removeEventListener('focus', handleFocus);
                editorElement.removeEventListener('blur', handleBlur);
                window.removeEventListener('beforeunload', handleBeforeUnload);
            }
        };
    }, []);

    // useEffect(() => {
    //     if (fancy && quillRef.current && initialHtml && !editorReady) {
    //         const editor = quillRef.current.getEditor();
    //         editor?.blur();
    //         editor.clipboard.dangerouslyPasteHTML(initialHtml);
    //         setEditorReady(true);
    //     }
    // }, [initialHtml, editorReady]);

    // const handleChange = (content) => {
    //     // setIsDirty(true);
    //     setHtmlContent(content); // This is the HTML string
    //     // console.log("is dirty", isDirty);
    //     if (!fancy) {
    //         onUpdate(content);
    //     }
    // };

    const onEditClick = () => {
        setIsFocused(true);
        // const editor = quillRef.current?.getEditor();
        // editor?.focus();

        // if (quillRef.current) {
        //     const editor = quillRef.current.getEditor();
        //     editor?.focus();
        // }
    }

    const onSaveClick = (e) => {
        setIsDirty(false);
        onSave();
    }


    const handleEditorChange = (content, delta, source, editor) => {
        const quill = quillRef.current?.getEditor();
        const range = quill?.getSelection();
        const isEnterKey = delta.ops.some(op => op.insert === '\n');
        setIsDirty(true);
        onChange(content); // Update parent state

        // Restore cursor position after update
        if (source === 'user' && range && !isEnterKey) {
            setTimeout(() => {
                quill.setSelection(range.index, range.length);
            }, 0);
        }
    };



    if (fancy) {
        return (<>
            <div className='d-flex flex-end small text-end px-1' style={{ justifyContent: 'flex-end' }}>
                <i className="bi bi-box-arrow-up-right me-2"></i>
                {isDirty ? <a onClick={onSaveClick} href="#?" >💾Save Changes</a> : <a href="#?" onClick={onEditClick}>✏️ Edit</a>}
            </div>
            <div className={`editor-wrapper ${isFocused ? 'focused' : 'blurred'}`}>
                <ReactQuill ref={quillRef} theme='snow' value={value} onChange={handleEditorChange} style={{ border: 'none' }} />
            </div>


        </>);
    } else {
        return (<div className={`editor-wrapper ${disabled ? 'blurred' : 'focused'}`}>
            <ReactQuill ref={quillRef} theme='snow' value={value} onChange={onChange} style={{ border: 'none' }} readOnly={disabled} />
        </div>);
    }


}

export default SDEditor;
